<template>
  <!-- 素材列表页 -->
  <div class="Materialpage">
    <div
      class="Materiaupload"
      v-if="this.$store.state.user.status === '已通过'"
    >
      <div class="altk" @click="uploadmaterial()">
        <i class="iconfont gos-shangchuan1"></i>
      </div>
      <span @click="uploadmaterial()"> 素材上传</span>
    </div>
    <div class="box">
      <div class="box-top">
        <div class="top">
          <div class="top-Major">
            <p>专业大类:</p>
            <el-radio-group
              @change="selmaterialis()"
              v-model="radio1"
              size="mini"
            >
              <el-radio-button label="全部"></el-radio-button>
              <el-radio-button
                v-for="item in Majorcategories"
                :key="item.id"
                :label="item.name"
              ></el-radio-button>
            </el-radio-group>
          </div>
          <div class="top-Major">
            <p>文件格式:</p>
            <el-radio-group
              @change="selmaterialis()"
              v-model="radio3"
              size="mini"
            >
              <el-radio-button label="全部"></el-radio-button>
              <!-- <el-radio-button label="付费"></el-radio-button> -->
              <el-radio-button label="视频"></el-radio-button>
              <el-radio-button label="图片"></el-radio-button>
              <el-radio-button label="动图"></el-radio-button>
            </el-radio-group>
          </div>
          <div class="top-Major">
            <p>是否付费:</p>
            <el-radio-group
              @change="selmaterialis()"
              v-model="radio2"
              size="mini"
            >
              <el-radio-button label="全部"></el-radio-button>
              <!-- <el-radio-button label="付费"></el-radio-button> -->
              <el-radio-button label="免费"></el-radio-button>
              <!-- <el-radio-button label="试看"></el-radio-button> -->
            </el-radio-group>
          </div>
          <div class="top-Major">
            <p>排序方式:</p>
            <el-radio-group v-model="radio4" size="mini">
              <el-radio-button
                @click.native="payAllotChange($event, 9)"
                label="默认"
              >
              </el-radio-button>
              <el-radio-button
                @click.native="payAllotChange($event, 1)"
                label="最新"
                >最新
                <img
                  class="ingmssj"
                  src="../../assets/thetriangle.png"
                  alt=""
                />
                <img
                  class="ingmssj"
                  v-if="zx && radio4 === '最新'"
                  src="../../assets/thetriangle1.png"
                  alt=""
                />
                <img class="ingmssj1" src="../../assets/sjs.png" alt="" />
                <img
                  class="ingmssj1"
                  v-if="zxx && radio4 === '最新'"
                  src="../../assets/Thetriangle2.png"
                  alt=""
                />
              </el-radio-button>
              <el-radio-button
                @click.native="payAllotChange($event, 2)"
                label="收藏"
              >
                收藏
                <img
                  class="ingmssj"
                  src="../../assets/thetriangle.png"
                  alt=""
                />
                <img
                  class="ingmssj"
                  v-if="sc && radio4 === '收藏'"
                  src="../../assets/thetriangle1.png"
                  alt=""
                />
                <img class="ingmssj1" src="../../assets/sjs.png" alt="" />
                <img
                  class="ingmssj1"
                  v-if="scc && radio4 === '收藏'"
                  src="../../assets/Thetriangle2.png"
                  alt=""
                />
              </el-radio-button>

              <el-radio-button
                label="浏览"
                @click.native="payAllotChange($event, 3)"
              >
                浏览
                <img
                  class="ingmssj"
                  src="../../assets/thetriangle.png"
                  alt=""
                />
                <img
                  class="ingmssj"
                  v-if="ll && radio4 === '浏览'"
                  src="../../assets/thetriangle1.png"
                  alt=""
                />
                <img class="ingmssj1" src="../../assets/sjs.png" alt="" />
                <img
                  class="ingmssj1"
                  v-if="lll && radio4 === '浏览'"
                  src="../../assets/Thetriangle2.png"
                  alt=""
                />
              </el-radio-button>
              <el-radio-button
                label="评分"
                @click.native="payAllotChange($event, 4)"
                >评分
                <img
                  class="ingmssj"
                  src="../../assets/thetriangle.png"
                  alt=""
                />
                <img
                  class="ingmssj"
                  v-if="pfjts && radio4 === '评分'"
                  src="../../assets/thetriangle1.png"
                  alt=""
                />
                <img class="ingmssj1" src="../../assets/sjs.png" alt="" />
                <img
                  class="ingmssj1"
                  v-if="pfjtx && radio4 === '评分'"
                  src="../../assets/Thetriangle2.png"
                  alt=""
                />
              </el-radio-button>
              <!-- <el-radio-button label="预约"></el-radio-button> -->
            </el-radio-group>
          </div>
        </div>
        <div class="pbbu">
          <ul>
            <!-- '@click="detailspage()" -->
            <li class="Live1" v-for="item in teplsta" :key="item.id">
              <div @click="detailspage(item.id)" class="Figuremove">
                <img
                  v-if="item.wjgs == '图片' || item.wjgs == '动图'"
                  :src="http + item.scwj"
                  alt=""
                />
                <!-- <video   v-if="item.wjgs == '视频' " :src="http+item.scwj" ></video> -->
              </div>
              <div class="Thetitle">
                <div class="Thetitle-top">
                  <p @click="detailspage(item.id)">
                    {{ item.scmc }}
                  </p>
                  <span @click="detailspage(item.id)">{{ item.wjgs }}</span>
                </div>
                <div class="Thetitle-center">
                  <span class="Thetitle-jg">{{ item.sfff }}</span>
                  <span
                    v-if="radio4 === '浏览' || radio4 === '默认'"
                    style="
                      font-size: 12px;
                      display: flex;
                      color: #999999;
                      line-height: 20px;
                    "
                  >
                    <i
                      class="iconfont gos-yanjing1"
                      style="margin-right: 10px"
                    ></i>
                    <p class="dzs">浏览量：{{ item.ll }}</p>
                  </span>
                  <span
                    v-if="radio4 === '收藏'"
                    style="
                      font-size: 12px;
                      display: flex;
                      color: #999999;
                      line-height: 20px;
                    "
                  >
                    <i
                      class="iconfont gos-aixin"
                      style="margin-right: 10px"
                    ></i>
                    <p class="dzs">收藏：{{ item.sc }}</p>
                  </span>
                  <span
                    v-if="radio4 === '最新'"
                    style="
                      font-size: 12px;
                      display: flex;
                      color: #999999;
                      line-height: 20px;
                    "
                  >
                    <p class="dzs">{{ item.statustime }}</p>
                  </span>
                  <span
                    v-if="radio4 === '评分'"
                    style="
                      font-size: 12px;
                      display: flex;
                      color: #999999;
                      line-height: 20px;
                    "
                  >
                    <el-rate disabled v-model.number="item.pf"></el-rate>
                  </span>
                </div>
                <div class="Thetitle-bottom">
                  <div class="Photoname">
                    <img :src="http + item.tx" alt="" />
                    <span>
                      {{ item.name }}
                    </span>
                  </div>
                  <el-button @click="detailspage(item.id)">立即查看</el-button>
                </div>
              </div>
            </li>
          </ul>
        </div>
        <el-pagination
          class="peges"
          @current-change="handleCurrentChangesss"
          :page-size="tepslds.rows"
          prev-text="上一页"
          next-text="下一页"
          background
          layout="prev, pager, next"
          :total="tepslds.total"
          :pager-count="5"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import { selmaterial, selsort } from "../../api/patient";
import Bus from "@/utils/bus";
export default {
  data() {
    return {
      http: this.$store.state.https,
      pfjts: false,
      pfjtx: false,
      ll: false,
      lll: false,
      sc: false,
      scc: false,
      zx: false,
      zxx: false,
      radio1: "全部",
      radio3: "全部",
      radio2: "全部",
      radio4: "默认",
      Majorcategories: [],
      teplsta: {},
      tepslds: {
        page: 1,
        rows: 12,
        total: 100,
      },
    };
  },

  mounted() {
    Bus.$emit("activeRouter", "/materialpage");
    if (this.$store.state.zusc1 !== 1) {
      this.radio1 = this.$store.state.zusc1.sort;
      this.radio3 = this.$store.state.zusc1.wjgs;
      this.radio2 = this.$store.state.zusc1.sfff;
      this.radio4 = "浏览";
    }
  },
  async created() {
    await this.selsortis();
    await this.selmaterialis();
  },

  methods: {
    async payAllotChange(el, val) {
      if (el.target.tagName === "STRONG" || el.target.tagName === "INPUT")
        return;
      if (val === 9) {
        this.zixinss = false;
        this.zixinsc = false;
        this.zixinll = false;
        this.zixinpf = false;
      }
      if (val === 1) {
        this.zixinsc = false;
        this.zixinll = false;
        this.zixinpf = false;
        if (this.zixinss) {
          this.zx = false;
          this.zxx = true;
          this.zzxsjs();
          this.selmaterialis();
          this.zixinss = false;
        } else {
          this.zzxsj();
          this.zxx = false;
          this.zx = true;
          this.selmaterialis();
          this.zixinss = true;
        }
      }
      if (val === 2) {
        this.zixinll = false;
        this.zixinss = false;
        this.zixinpf = false;
        if (this.zixinsc) {
          this.sc = false;
          this.scc = true;
          this.collectionis();
          this.selmaterialis();
          this.zixinsc = !this.zixinsc;
        } else {
          this.sc = true;
          this.scc = false;
          this.collectioni();
          this.selmaterialis();
          this.zixinsc = !this.zixinsc;
        }
      }
      if (val === 3) {
        this.zixinsc = false;
        this.zixinss = false;
        this.zixinpf = false;
        if (this.zixinll) {
          this.ll = false;
          this.lll = true;
          this.llis();
          this.selmaterialis();
          this.zixinll = !this.zixinll;
        } else {
          this.ll = true;
          this.lll = false;
          this.lliss();
          this.selmaterialis();
          this.zixinll = !this.zixinll;
        }
      }
      if (val === 4) {
        this.zixinsc = false;
        this.zixinss = false;
        this.zixinll = false;
        if (this.zixinpf) {
          this.pfjtx = true;
          this.pfjts = false;

          this.pfidx();
          this.selmaterialis();
          this.zixinpf = !this.zixinpf;
        } else {
          this.pfjts = true;
          this.pfjtx = false;
          this.pfids();
          this.selmaterialis();
          this.zixinpf = !this.zixinpf;
        }
      }
    },
    // 评分
    // 评分
    pfidx() {
      this.ll = false;
      this.lll = false;
      this.sc = false;
      this.scc = false;
      this.zx = false;
      this.zxx = false;
    },
    pfids() {
      this.ll = false;
      this.lll = false;
      this.sc = false;
      this.scc = false;
      this.zx = false;
      this.zxx = false;
    },
    // 浏览倒
    llis() {
      this.pfjts = false;
      this.pfjtx = false;

      this.sc = false;
      this.scc = false;
      this.zx = false;
      this.zxx = false;
    },
    // 浏览
    lliss() {
      this.pfjts = false;
      this.pfjtx = false;

      this.sc = false;
      this.scc = false;
      this.zx = false;
      this.zxx = false;
    },
    // 收藏倒
    collectionis() {
      this.pfjts = false;
      this.pfjtx = false;
      this.ll = false;
      this.lll = false;

      this.zx = false;
      this.zxx = false;
    },
    // 收藏
    collectioni() {
      this.pfjts = false;
      this.pfjtx = false;
      this.ll = false;
      this.lll = false;

      this.zx = false;
      this.zxx = false;
    },
    // 最新
    async zzxsj() {
      this.pfjts = false;
      this.pfjtx = false;
      this.ll = false;
      this.lll = false;
      this.sc = false;
      this.scc = false;
    },
    async zzxsjs() {
      this.pfjts = false;
      this.pfjtx = false;
      this.ll = false;
      this.lll = false;
      this.sc = false;
      this.scc = false;
    },

    // 专业大类筛选
    selsortis() {
      var data = new FormData();
      data.append("page", 1);
      data.append("rows", 100);
      selsort(data).then((res) => {
        this.Majorcategories = res.rows;
      });
    },
    // 列表
    async selmaterialis() {
      var data = new FormData();
      data.append("page", this.tepslds.page);
      data.append("rows", this.tepslds.rows);
      if (this.radio1 !== "全部") {
        data.append("sort", this.radio1);
      }
      if (this.radio3 !== "全部") {
        data.append("wjgs", this.radio3);
      }
      if (this.radio2 !== "全部") {
        data.append("jg", this.radio2);
      }
      if (this.sc === true) {
        data.append("px", "收藏倒");
      }
      if (this.scc === true) {
        data.append("px", "收藏");
      }
      if (this.zx === true) {
        data.append("px", "最新");
      }
      if (this.zxx === true) {
        data.append("px", "最新倒");
      }
      if (this.lll === true) {
        data.append("px", "浏览");
      }
      if (this.ll === true) {
        data.append("px", "浏览倒");
      }
      if (this.pfjtx === true) {
        data.append("px", "评分");
      }
      if (this.pfjts === true) {
        data.append("px", "评分倒");
      }
      data.append("status", "已通过");
      await selmaterial(data).then((res) => {
        this.teplsta = res.rows;
        this.tepslds.total = res.total;

        for (let s = 0; s < this.teplsta.length; s++) {
          var a = this.teplsta[s].statustime.split(" ");
          this.teplsta[s].statustime = a[0];
          this.teplsta[s].pf = Number(this.teplsta[s].pf);
        }
      });
    },
    // 跳转素材上传
    uploadmaterial() {
      if (this.$store.state.isLogin) {
        this.$router.push("/Uploadpagem");
      } else {
        this.$message({
          showClose: true,
          message: "请先进行登录",
          type: "warning",
        });
      }
    },
    // 素材详情
    detailspage(item) {
      this.$router.push("/materialdetailspage");
      this.$store.commit("sucaixingqi", item);
    },
    handleCurrentChangesss(val) {
      this.tepslds.page = val;
      this.selmaterialis();
    },
  },
  destroyed() {
    this.$store.commit("Stateofthe1", 1);
  },
};
</script>
<style lang="scss" scoped>
.Materialpage {
  box-shadow: 0px 0px 3px 4px rgba(6, 0, 1, 0.07);
  margin-top: 4px;
  background: #fff;
  padding-top: 4px;
  padding-bottom: 88px;
  .box {
    width: 1190px;
    margin: auto;
    .box-top {
      padding: 0px 50px;
      // height: 3000px;
      .top {
        .top-Major {
          padding-top: 16px;
          padding-bottom: 15px;
          width: 100%;
          // height: 60px;
          line-height: 30px;
          display: flex;
          text-align: left;
          border-bottom: 1px solid #f3f3f3;
          p {
            height: 30px;
            font-size: 14px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #999999;
            margin-right: 21px;
          }
          .el-radio-group {
            min-height: 100%;
            .el-radio-button {
              ::v-deep .el-radio-button__inner {
                width: 79px;
                padding: 0px;
                text-align: center;
                height: 30px;
                font-size: 14px;
                font-family: Source Han Sans CN;
                font-weight: 400;
                color: #333333;
                border: 0px solid;
                line-height: 30px;
              }
              ::v-deep
                .el-radio-button__orig-radio:checked
                + .el-radio-button__inner {
                width: 79px;
                height: 30px;
                background: #4ccaff;
                border-radius: 14px;
                color: #fff;
              }
            }
          }
        }
      }
    }
  }
}
.ingmssj {
  position: absolute;
  right: 11px;
  top: 7px;
  width: 10px;
  height: 8px;
}
.ingmssj1 {
  position: absolute;
  right: 11px;
  top: 15px;
  width: 10px;
  height: 8px;
}
.pbbu {
  text-align: left;
  margin-top: 50px;
  min-height: 720px;
  ul {
    display: flex;
    flex-wrap: wrap;
    li {
      width: 247px;
      height: 265px;
      background: #ffffff;
      border: 1px solid #f6f6f6;
      box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.22);
      border-radius: 6px;
      margin-bottom: 20px;
      margin-right: 20px;
      transition: all 0.2s;
      .Thetitle {
        // display: flex;
        padding: 9px 20px 0px 20px;
        // margin-top: 10px;
        // justify-content: space-between;
        // width: 213px;
        .Thetitle-top {
          display: flex;
          justify-content: space-between;
          p {
            font-size: 14px;
            font-family: Source Han Sans CN;
            font-weight: bold;
            color: #333333;
            width: 150px;
            height: 18px;
            display: -webkit-box; /**对象作为伸缩盒子模型展示**/
            -webkit-box-orient: vertical; /**设置或检索伸缩盒子对象的子元素的排列方式**/
            -webkit-line-clamp: 1; /**显示的行数**/
            overflow: hidden; /**隐藏超出的内容**/
          }
          span {
            font-size: 12px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #333333;
          }
        }
      }
    }
  }
}
.Live1:hover {
  transform: translateY(-2px);
  box-shadow: 0 12px 20px 0 rgba(95, 101, 105, 0.15);
}
.Thetitle-center {
  margin-top: 12px;
  display: flex;
  justify-content: space-between;
  .Thetitle-jg {
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: bold;
    color: #ff1616;
  }
  .xinx {
    width: 12px;
    height: 11px;
    color: #999999;
    margin-right: 5px;
  }
}
.Thetitle-bottom {
  display: flex;
  justify-content: space-between;
  margin-top: 11px;
  border-top: 1px solid #f6f6f6;
  padding: 10px 0;
  .Photoname {
    display: flex;
    img {
      width: 22px;
      height: 22px;
      border-radius: 50%;
      margin-right: 8px;
    }

    span {
      font-size: 12px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #333333;
      line-height: 22px;
      width: 110px;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 1;
      overflow: hidden;
    }
  }
  .el-button--default {
    padding: 0px;
    text-align: center;
    font-size: 12px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #ffffff;
    width: 67px;
    height: 23px;
    background: #4ccaff;
    border-radius: 4px;
  }
  .el-button:active {
    border-color: #4ccaff;
  }
}
.peges {
  margin-top: 40px;
}
.Materiaupload {
  position: fixed;
  top: 15.6rem;
  right: 11.2rem;
  span {
    font-size: 12px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #4ccaff;
  }
}
.altk {
  width: 48px;
  height: 48px;
  background: #4ccaff;
  border-radius: 6px;
  text-align: center;
  line-height: 48px;
  margin-bottom: 8px;
  .iconfont {
    font-size: 28px;
    color: #fff;
  }
}
.Figuremove {
  width: 247px;
  height: 151px;
  // background: #409EFF;
  border-radius: 6px 6px 0px 0px;
  img {
    // position:absolute;
    width: 100%;
    height: 100%;
  }
  video {
    width: 100%;
    height: 100%;
  }
}
.el-button:hover {
  background: #4ccaffc9;
}
.el-pagination {
  ::v-deep span {
    padding: 0 10px;
  }
}
img {
  object-fit: contain;
}
// 适配手机端
@media (max-width: 768px) {
  .Materialpage {
    width: 100vw;
    .box {
      width: 95vw;
      .box-top {
        padding: 0px;
        .top {
          .top-Major {
            width: 95vw;
            flex-shrink: 0; /* 防止项目在空间不足时缩小 */
            white-space: nowrap; /* 确保项目不换行 */
            /* 样式调整，根据需要设置宽度、间距等 */
            margin-right: 10px;
            /* 其他样式 */
            overflow-x: auto;
          }
        }
      }
    }
  }

  .ingmssj {
    position: absolute;
    right: 11px;
    top: 7px;
    width: 10px;
    height: 8px;
  }
  .ingmssj1 {
    position: absolute;
    right: 11px;
    top: 15px;
    width: 10px;
    height: 8px;
  }
  .pbbu {
    width: 98vw;
    ul {
      li {
        width: 45vw;
        height: 240px;
        margin-right: 10px;
        .Thetitle {
          padding: 9px 5px 0px 5px;
          .Thetitle-top {
            p {
              width: 140px;
            }
          }
        }
      }
    }
  }
  .Thetitle-center {
    margin-top: 5px;
  }
  .Thetitle-bottom {
    margin-top: 5px;
    padding: 5px 0;
    .Photoname {
      span {
        width: 80px;
      }
    }
  }

  .Materiaupload {
    position: fixed;
    top: 18rem;
    right: 1rem;
    z-index: 1;
  }

  .Figuremove {
    width: 45vw;
    height: 151px;
  }
  .el-pagination {
    ::v-deep span {
      padding: 0 5px;
    }
  }
}
</style>
